function fetchJson(url, options = {}) {
	return fetch(url, {
		credentials: 'same-origin',
		...options,
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			...(options.headers || {}),
		},
	}).then(res => {
		if (!res.ok) throw new Error('Request failed');
		return res.json();
	});
}

function buildDataUrl(root, startDate, endDate, phone) {
	const url = new URL(root.dataset.dataUrl, window.location.origin);
	url.searchParams.set('startDate', startDate);
	url.searchParams.set('endDate', endDate);
	if (phone) {
		url.searchParams.set('phone', phone);
	} else {
		url.searchParams.delete('phone');
	}
	return url.toString();
}

function buildExportCsvUrl(root, startDate, endDate, phone) {
	const base = root.dataset.exportShippingCsvUrl;
	if (!base) return null;

	const url = new URL(base, window.location.origin);
	url.searchParams.set('startDate', startDate);
	url.searchParams.set('endDate', endDate);
	if (phone) {
		url.searchParams.set('phone', phone);
	} else {
		url.searchParams.delete('phone');
	}
	return url.toString();
}

function buildActionUrl(base, orderId) {
	if (!base) return null;
	return new URL(`${base.replace(/\/+$/, '')}/${orderId}`, window.location.origin).toString();
}

export function initOrdersBoardPage() {
	const root = document.querySelector('[data-orders-board-page]');
	if (!root) return;

	const startDateInput = root.querySelector('[data-orders-board-date-start]');
	const endDateInput = root.querySelector('[data-orders-board-date-end]');
	const phoneInput = root.querySelector('[data-orders-board-phone]');
	if (!startDateInput || !endDateInput || !phoneInput) return;

	let refreshTimer = null;
	let phoneDebounceTimer = null;
	const refreshSeconds = parseInt(root.dataset.refreshSeconds || '0', 10) || 15;

	function refresh() {
		const content = root.querySelector('[data-orders-board-content]');
		const shippingContent = root.querySelector('[data-orders-board-shipping-content]');
		if (!content && !shippingContent) {
			return Promise.resolve();
		}

		const url = buildDataUrl(
			root,
			startDateInput.value,
			endDateInput.value,
			phoneInput.value.trim()
		);
		return fetchJson(url).then(data => {
			if (content) {
				content.innerHTML = typeof data.html === 'string' ? data.html : '';
			}
			if (shippingContent) {
				shippingContent.innerHTML = typeof data.shippingHtml === 'string' ? data.shippingHtml : '';
			}
		});
	}

	function schedule() {
		clearInterval(refreshTimer);
		refreshTimer = setInterval(() => {
			refresh().catch(console.error);
		}, Math.max(5, refreshSeconds) * 1000);
	}

	function updateExportCsvLink() {
		const exportLink = root.querySelector('[data-shipping-export-csv]');
		if (!exportLink) return;

		const url = buildExportCsvUrl(
			root,
			startDateInput.value,
			endDateInput.value,
			phoneInput.value.trim()
		);
		if (url) {
			exportLink.setAttribute('href', url);
		}
	}

	function handleFilterChange() {
		const url = new URL(window.location.href);
		url.searchParams.set('startDate', startDateInput.value);
		url.searchParams.set('endDate', endDateInput.value);
		const phone = phoneInput.value.trim();
		if (phone) {
			url.searchParams.set('phone', phone);
		} else {
			url.searchParams.delete('phone');
		}
		url.searchParams.delete('date');
		window.history.replaceState({}, '', url.toString());
		updateExportCsvLink();
		refresh().catch(console.error);
	}

	startDateInput.addEventListener('change', handleFilterChange);
	startDateInput.addEventListener('input', handleFilterChange);
	endDateInput.addEventListener('change', handleFilterChange);
	endDateInput.addEventListener('input', handleFilterChange);
	phoneInput.addEventListener('change', handleFilterChange);
	phoneInput.addEventListener('input', () => {
		clearTimeout(phoneDebounceTimer);
		phoneDebounceTimer = setTimeout(handleFilterChange, 400);
	});

	document.addEventListener('click', e => {
		const confirmShippingBtn = e.target.closest('[data-shipping-confirm-payment]');
		const cancelShippingBtn = e.target.closest('[data-shipping-cancel]');
		const confirmBtn = e.target.closest('[data-orders-board-confirm-payment]');
		const cancelBtn = e.target.closest('[data-orders-board-cancel]');
		const btn = confirmShippingBtn || cancelShippingBtn || confirmBtn || cancelBtn;
		if (!btn) return;

		const orderId = btn.dataset.orderId;
		if (!orderId) return;

		let actionUrl = null;
		if (confirmShippingBtn) {
			actionUrl = buildActionUrl(root.dataset.confirmShippingPaymentUrl, orderId);
		} else if (cancelShippingBtn) {
			actionUrl = buildActionUrl(root.dataset.cancelShippingOrderUrl, orderId);
		} else if (confirmBtn) {
			actionUrl = buildActionUrl(root.dataset.confirmPaymentUrl, orderId);
		} else if (cancelBtn) {
			actionUrl = buildActionUrl(root.dataset.cancelOrderUrl, orderId);
		}

		if (!actionUrl) return;

		if ((cancelBtn || cancelShippingBtn) && !window.confirm('Cancel this order?')) {
			return;
		}

		btn.setAttribute('disabled', 'disabled');

		fetchJson(actionUrl, { method: 'POST' })
			.then(() => refresh())
			.catch(err => {
				console.error(err);
				btn.removeAttribute('disabled');
				window.alert('Action failed. Make sure you are logged in with order access.');
			});
	});

	refresh().catch(console.error);
	schedule();
	updateExportCsvLink();
}
